/*
 * Reads a fetch Response body according to the status code so both response
 * envelopes used by the backend are handled correctly:
 *   - 401 / 403 -> FastAPI default error format: { detail }
 *   - 200 / 400 / 404 / 409 / 500 -> project standard format: { status, message, data }
 * Shared by every Role Management screen (list + Permission Configuration)
 * so 404/409/400/500 all surface `message` the same way.
 */
export const parseResponseBody = async (response) => {
  let body = null;
  try {
    body = await response.json();
  } catch (err) {
    body = null;
  }

  if (response.status === 401 || response.status === 403) {
    return {
      ok: false,
      message: body?.detail || "You are not authorized to perform this action.",
      data: null,
    };
  }

  if (!response.ok || body?.status === false) {
    return {
      ok: false,
      message: body?.message || `Something went wrong (${response.status}). Please try again.`,
      data: body?.data ?? null,
    };
  }

  return { ok: true, message: body?.message || "", data: body?.data ?? null };
};
